import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./card_slide.css";
import { Button } from "@mantine/core";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Tooltip,
} from "@material-tailwind/react";
export const SlideData = [
  {
    id: 1,
    name: "something",
    cate: "recom",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fchoose_reason.jpg?alt=media&token=d9b54850-86c7-4475-9b47-3fa9f1aa9780",
  },
  {
    id: 2,
    name: "something",
    cate: "recom",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio1.jpg?alt=media&token=24b06ee2-0fca-4d6c-9dc9-829fe35a6980",
  },
  {
    id: 3,
    name: "something",
    cate: "recom",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio4.jpg?alt=media&token=39b94acf-3ce4-46ad-b81d-c78ef9ad2e53",
  },
  {
    id: 4,
    name: "something",
    cate: "recom",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio5.jpg?alt=media&token=a04e6eee-34eb-4559-a9c4-c3d6257591c9",
  },
  {
    id: 5,
    name: "something",
    cate: "recom",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio6.jpg?alt=media&token=21a087f6-89b6-4336-9803-1398a4d5b694",
  },
  {
    id: 6,
    name: "something",
    cate: "recom",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio8.jpg?alt=media&token=bc6485b0-2962-437d-b9cf-6dec7345309f",
  },
  {
    id: 7,
    name: "something",
    cate: "recom",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fportfolio11.jpg?alt=media&token=a4183689-a2b0-402d-b161-eb1f2aad36eb",
  },
];

const CardSlide = () => {
  const [defaultImage, setDefaultImage] = useState({});
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleErrorImage = (data) => {
    setDefaultImage((prev) => ({
      ...prev,
      [data.target.alt]: data.target.alt,
      linkDefault: "",
    }));
  };

  return (
    <div className="App mb-20">
      <p className="text-sm md:text-3xl text-[#D8AE96] uppercase text-center mb-4">
        Featured Products
      </p>
      <Slider {...settings}>
        {SlideData.map((item) => (
          // <div key={item.id} className="card">
          //   <div className="card-top">
          //     <img src={item.img} alt={item.name} onError={handleErrorImage} />
          //     <h1>{item.name}</h1>
          //   </div>
          //   <div className="card-bottom">
          //     <h3>{item.price}</h3>
          //     <span className="category">{item.name}</span>
          //   </div>
          //   <button className="bg-white px-5 rounded hover:scale-105 transition outline-none border-none text-xs py-2 mt-3 ml-4 text-gray-800 font-bold uppercase">
          //     shop now
          //   </button>
          // </div>
          <Card className="w-96" key={item.id}>
            <CardHeader floated={false} className="h-80">
              <img
                src={item.img}
                alt="profile-picture"
                className="h-full w-full object-center object-cover"
              />
            </CardHeader>
            <CardBody className="text-center">
              <Typography
                variant="h5"
                color="blue-gray"
                className="mb-2 font-light"
              >
                {item.name}
              </Typography>
              <Typography
                color="blue"
                className="font-medium text-xs"
                textGradient
              >
                {item.cate}
              </Typography>
            </CardBody>
            <CardFooter className="flex justify-center gap-7 pt-2">
              <Tooltip content="Like">
                <Typography
                  as="a"
                  href="#facebook"
                  variant="lead"
                  color="blue"
                  textGradient
                >
                  <i className="fab fa-facebook" />
                </Typography>
              </Tooltip>
              <Tooltip content="Follow">
                <Typography
                  as="a"
                  href="#twitter"
                  variant="lead"
                  color="light-blue"
                  textGradient
                >
                  <i className="fab fa-twitter" />
                </Typography>
              </Tooltip>
              <Tooltip content="Follow">
                <Typography
                  as="a"
                  href="#instagram"
                  variant="lead"
                  color="purple"
                  textGradient
                >
                  <i className="fab fa-instagram" />
                </Typography>
              </Tooltip>
            </CardFooter>
          </Card>
        ))}
      </Slider>
    </div>
  );
};

export default CardSlide;
